import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { url: String }

    click(event) {
        event.preventDefault()
        // Open download in nieuw venster/tab
        window.open(this.urlValue, '_blank')
    }
}